export const PASTEBOARD_TOKEN_SEARCH_PARAM_KEY = "detour_pasteboard_token";
export const REDIRECT_COOKIE_PREFIX = "redirect_attempted_";

function escapeRegex(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Keep this list limited to bots we explicitly disallow in robots.txt.
// Preview/unfurl bots (Slack, X/Twitter, Discord, WhatsApp, Facebook, etc.)
// should stay allowed so link preview cards can be generated.
export const ROBOTS_DISALLOWED_USER_AGENTS = [
  "GPTBot",
  "ChatGPT-User",
  "PetalBot",
  "SemrushBot",
  "SERankingBacklinksBot",
  "AhrefsBot",
  "MJ12bot",
  "DotBot",
  "Bytespider",
  "ClaudeBot",
  "anthropic-ai",
  "PerplexityBot",
  "cohere-ai",
  "meta-externalagent",
] as const;

// Create regex patterns for disallowed bots to use in matching user agents
export const BOT_USER_AGENT_PATTERNS = [
  ...ROBOTS_DISALLOWED_USER_AGENTS.map(
    (userAgent) => new RegExp(escapeRegex(userAgent), "i")
  ),
  /Googlebot/i,
  /GoogleOther/i,
  /Google-Read-Aloud/i,
  /AdsBot-Google/i,
  /FeedFetcher-Google/i,
  /APIs-Google/i,
  /Google-InspectionTool/i,
  /Bingbot/i,
  /Slurp/i,
  /DuckDuckBot/i,
  /Baiduspider/i,
  /YandexBot/i,
  /facebookexternalhit/i,
  /Facebot/i,
  /Twitterbot/i,
  /LinkedInBot/i,
  /Applebot/i,
  /Slackbot/i,
  /Slack-ImgProxy/i,
  /WhatsApp/i,
  /TelegramBot/i,
  /Discordbot/i,
  /HeadlessChrome/i,
  /PhantomJS/i,
  /python-requests/i,
  /curl\//i,
  /wget\//i,
];
